import { defineStore } from 'pinia'
import DeviceSettingsState, { DeviceSettingsStateType } from './state'
import { DeviceSettingsActions, DeviceSettingsActionsType } from './actions'
import { DeviceSettingsGetters } from './getters'

export const useDeviceSettingsStore = defineStore<
  'deviceSettings',
  DeviceSettingsStateType,
  typeof DeviceSettingsGetters,
  DeviceSettingsActionsType
>('deviceSettings', {
  state: DeviceSettingsState,
  actions: DeviceSettingsActions,
  getters: DeviceSettingsGetters,
})
